document.addEventListener('DOMContentLoaded', () => {

	// Fix that adds iframe support to WooCommerce built-in PhotoSwipe.
	// It requires `data-iframe-src` attribute.
    MutationObserver = window.MutationObserver;
    const productGalleryObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                const lightboxImage = node.querySelector('img.pswp__img');
                if (lightboxImage) {
                    // Match product thumbnail that has identical image URL to the active lightbox image and contains iframe source attribute.
                    let thumbnailIframe = document.querySelector('.woocommerce-product-gallery__image a[href="' + lightboxImage.getAttribute('src') + '"][data-video-id]');
                    if (thumbnailIframe) {
                        node.innerHTML = ''; // Remove default image (child elements).
                        node.insertAdjacentHTML('beforeend', '<div class="video-container"><iframe class="video-item" id="' + thumbnailIframe.getAttribute('data-video-id') + '" src="' + thumbnailIframe.getAttribute('data-iframe-src') + '?enablejsapi=1" width="100%" height="100%" frameborder="0" allowscriptaccess="always" enablejsapi="1" allow="autoplay"></iframe></div>');
                        window.dispatchEvent(new Event('resize')); // Adjust iframe dimentions.
                    }
                }
            });
        });
    });

    // Look for changes in the active lightbox items.
    const productGalleryList = document.querySelectorAll('.pswp__container .pswp__item:not([style*="display: none"])');
    productGalleryList.forEach((productGallery) => {
        productGalleryObserver.observe((productGallery), {
            attributeFilter: ['style'],
            attributes: true,
            childList: true,
        });
    });

	if (!document.body.classList.contains('single-product')) {
		return;
	}

	/**
	 * Single product gallery, adding video support.
	 */
	jQuery($ => {

			let numbImgs    = 0;
			let numbVids    = 0;
			let thumbHeight = 0;

			/* See what images are for videos and add class to corresponding thumbnail (by position) so we can target then */
			$('.woocommerce-product-gallery__image.video').each(function() {
				$('ol.flex-control-thumbs li').eq($(this).index()).addClass('video-thumb').addClass('hidden');
			});

			const thumbHolder = $('ol.flex-control-thumbs');
			const vidThumbs   = $('ol.flex-control-thumbs li.video-thumb');
			const imgThumbs   = $('ol.flex-control-thumbs li:not(.video-thumb)');

			/* Count the images and videos so we can add classes to show/hide them */
			numbImgs = 'img-count-' + imgThumbs.length;
			numbVids = 'vid-count-' + vidThumbs.length;

			thumbHolder.addClass(numbImgs).addClass(numbVids).before('<button class="flex-control-thumbs-prev" aria-label="Forrige"></button>');

			$('button.flex-control-thumbs-prev').on('click', function() {
				thumbHeight = imgThumbs.outerHeight(true);

				$(thumbHolder).animate({
					scrollTop: '-=' + (thumbHeight * 4 + 2) + 'px',
				}, 500);
			});

			thumbHolder.addClass(numbImgs).after('<button class="flex-control-thumbs-more" aria-label="Neste"></button>');

			$('button.flex-control-thumbs-more').on('click', function() {
				thumbHeight = imgThumbs.outerHeight(true);

				$(thumbHolder).animate({
					scrollTop: '+=' + (thumbHeight * 4 + 2) + 'px',
				}, 500);
			});

			setTimeout(function() {
				/* If thumbnail list is scrolled to bottom, hide the arrow down button */
				thumbHolder.scroll(function() {
					if ( $(thumbHolder).scrollTop() + $(thumbHolder).innerHeight() + 50 >= $(thumbHolder)[0].scrollHeight ) {
						$(this).addClass('no-load-more');
					} else {
						$(this).removeClass('no-load-more');
					}

					if ( $(thumbHolder).scrollTop() > 50 ) {
						$('button.flex-control-thumbs-prev').addClass('show');
					} else {
						$('button.flex-control-thumbs-prev').removeClass('show');
					}
				});
			}, 500);

		if (!document.querySelector('.woocommerce-product-gallery__image.video')) {
			return; // Do not allow to switch between images and videos if the gallery does not contains any video.
		}

				/* Switch between images and video. Button is only visible on mobile if both img and video exist */
				if ( ( imgThumbs.length > 0 ) && ( vidThumbs.length > 0 ) ) {
					$('a.ws-product-video-toggle.vid-icon').removeClass('hidden');
				}

		const videoToggles = document.querySelectorAll('a.ws-product-video-toggle');
		let currentSlideTypeSelector = ':not(.video-thumb)'; // By default, show only images.

		videoToggles.forEach(toggleElement => {
			toggleElement.addEventListener('click', () => {
				vidThumbs.toggleClass('hidden');
				imgThumbs.toggleClass('hidden');

				thumbHolder.removeClass('no-load-more').scrollTop(0);

				videoToggles.forEach(videoToggle => {
					videoToggle.classList.toggle('hidden');
				});

				if (currentSlideTypeSelector !== '.video-thumb') {
					currentSlideTypeSelector = '.video-thumb';
					thumbHolder.addClass('showing-video');
				} else {
					currentSlideTypeSelector = ':not(.video-thumb)';
					thumbHolder.removeClass('showing-video');
				}

				const allSlidesOfType = document.querySelectorAll('ol.flex-control-thumbs li img');
				const firstSlideOfType = document.querySelector('ol.flex-control-thumbs li' + currentSlideTypeSelector + ' img');

				var slideIndex = [].findIndex.call(allSlidesOfType, element => {
					return element === firstSlideOfType;
				});

				$('.woocommerce-product-gallery').flexslider(slideIndex); // Go to a default slide of the given type (image or video).
			});
		});

				/* Stop iframe-video on slideshow interaction. Done by resetting src due to lack of control over PhotoSwipe in WooCommerce */
				$('.pswp__button').on( 'click touchend', function() {
					var pswpScrollWrap = $(this).closest('.pswp__scroll-wrap');
					var videoIframes = $(pswpScrollWrap).find('iframe.video-item');
					$(videoIframes).each(function() {
						$(this).attr( 'src', function ( i, val ) {
							return val;
						});
					});
				});

	});

});
